import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { IMG } from "@/lib/images";

export const PageHero = ({ eyebrow, title, lead, crumbs = [], children, image = IMG.teamOffice, testId = "page-hero" }) => (
  <section className="relative overflow-hidden ink" data-testid={testId}>
    <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" loading="eager" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0e1013] via-[#0e1013]/85 to-[#0e1013]/40" aria-hidden="true" />
    <div className="absolute inset-0 opacity-60" style={{ backgroundImage: "repeating-linear-gradient(135deg, rgba(255,255,255,0.03) 0 1px, transparent 1px 22px)" }} aria-hidden="true" />
    <div className="container-x relative py-20 sm:py-24 lg:py-32">
      {crumbs.length > 0 && (
        <nav aria-label="Breadcrumb" className="mb-8 inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-xs font-medium text-white/70">
          <Link to="/" className="hover:text-white">Home</Link>
          {crumbs.map((c) => (
            <span key={c.label} className="inline-flex items-center gap-1.5"><ChevronRight className="h-3 w-3" />{c.to ? <Link to={c.to} className="hover:text-white">{c.label}</Link> : <span className="text-white">{c.label}</span>}</span>
          ))}
        </nav>
      )}
      <Reveal className="max-w-3xl">
        {eyebrow && <span className="eyebrow eyebrow-light">{eyebrow}</span>}
        <h1 className="section-title-lg mt-4 text-white">{title}</h1>
        {lead && <p className="lead mt-6 max-w-2xl text-white/70">{lead}</p>}
        {children}
      </Reveal>
    </div>
  </section>
);
